<template>
    <div class="contract-setting-comp">
        <modal class="delete" :display="modalState.deleteRentalAgent" @modalStatus="closeModal('CHARTER')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>租賃住宅管理人員</h1>
            <div class="content">
                確定刪除嗎？當您按下確認刪除後，將直接刪除此租賃住宅管理人員
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteManager('CHARTER')">確認刪除</button>
            </div>
        </modal>
        <modal class="delete" :display="modalState.deleteEstateAgent" @modalStatus="closeModal('ESCROW')" >
            <img class="alarm-img" src="@/assets/img/icon/modal_alarm.svg" alt="">
            <h1>不動產經紀人</h1>
            <div class="content">
                確定刪除嗎？當您按下確認刪除後，將直接刪除此不動產經紀人
            </div>
            <div class="btn-group">
                <button class="default-button" @click="deleteManager('ESCROW')">確認刪除</button>
            </div>
        </modal>
        <new-manager :type="status.addManagerType" :isEdit="status.isEdit" :editObj="status.editObj" @editSaved="setEditDefault()"  @update="getContractSetting()"></new-manager>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                企業資訊
            </div>
            <div class="toogle-body block" slot="toogle-body">

                <div v-if="isLoading" class="is-loading">
                    <table-loading />
                </div>
                <div v-if="!isLoading" class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                             租賃住宅服務業登記證字號
                        </div>
                        <span v-show="error.registrationCertificateNum" class="error-with-title">{{error.registrationCertificateNum}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.registrationCertificateNum}" type="text" v-model="contractSetting.registrationCertificateNum" placeholder="例：(108)北市租登字第000001號">
                    </div>
                </div>
                <div v-if="!isLoading" class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                             公司連絡電話
                        </div>
                        <span v-show="error.companyTel" class="error-with-title">{{error.companyTel}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.companyTel}" type="text" v-model="contractSetting.companyTel" placeholder="請輸入公司連絡電話">
                    </div>
                </div>
                <div v-if="!isLoading" class="col2-input">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                             電子郵件信箱
                        </div>
                        <span v-show="error.companyMail" class="error-with-title">{{error.companyMail}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.companyMail}" type="text" v-model="contractSetting.companyMail" placeholder="請輸入電子郵件信箱">
                    </div>
                </div>
                <div v-if="!isLoading" class="image-cover">
                        <label class="button-font input-label">
                            <div class="title">
                                <span class="must-fill"></span>
                                公司簽署合約用印章
                            </div>
                            <span v-show="error.corporateSeal" class="error-with-title">{{error.corporateSeal}}</span>
                        </label>
                        <div class="input-error-group">
                            <div v-if="!contractSetting.corporateSeal.length && !contractSetting.previewImg" class="cover-block" :class="{'img-error': error.corporateSeal}">
                                <file-upload
                                class="upload-btn"
                                post-action="/upload/post"
                                input-id="rentalCertificate"
                                :size="1024 * 5"
                                :maximum="1"
                                :multiple="true"
                                v-model="contractSetting.corporateSeal"
                                @input-file="inputFile"
                                @input-filter="inputFilter"
                                ref="uploadCover">
                                    <img class="upload-icon" src="@/assets/img/icon/upload_biz.svg" alt="">
                                    上傳圖片
                                </file-upload>
                            </div>
                            <div v-else class="cover-preview">
                                <div class="preview">
                                    <img v-show="flag.isResize" ref="stamp" :src="previewImg" />
                                </div>
                                <file-upload
                                    class="replace"
                                    post-action="/upload/post"
                                    input-id="rentalCertificate"
                                    :size="1024 * 5"
                                    :maximum="1"
                                    :multiple="true"
                                    :drop="true"
                                    :drop-directory="true"
                                    v-model="contractSetting.corporateSeal"
                                    @input-file="inputFile"
                                    @input-filter="inputFilter"
                                    ref="uploadCover">
                                        取代圖片
                                </file-upload>
                            </div>
                        </div>
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                包租 - 租賃住宅管理人員
            </div>
            <div class="toogle-body block" slot="toogle-body">
                <div v-if="isLoading" class="is-loading">
                    <table-loading />
                </div>
                <div class="content" v-if="list.rentalAgentList.length">
                    <div class="table-title h-align">
                        <div class="name">姓名</div>
                        <div class="certification">認證字號</div>
                        <div class="address">通訊地址</div>
                        <div class="phone">聯絡電話</div>
                        <div class="signature">上傳簽名</div>
                        <div class="action">操作</div>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li class="h-align" v-for="(item, index) in list.rentalAgentList" :key="'rentalAgentList'+index">
                                <div class="name">{{item.managerName}}</div>
                                <div class="certification">{{item.certificateNum}}</div>
                                <div class="address">{{item.managerAddress}}</div>
                                <div class="phone">{{item.managerTel}}</div>
                                <div class="signature">
                                    <div v-show="item.managerSignature" class="image-wrap">
                                        <img  ref="rental" :src="item.managerSignature" alt="">
                                    </div>
                                    <div v-show="!item.managerSignature">
                                        -
                                    </div>
                                </div>
                                <div class="action">
                                    <img src="@/assets/img/icon/edit_gray.svg" @click="status.seleted=index, editManager('CHARTER')" alt="">
                                    <img src="@/assets/img/icon/trash2.svg" @click="status.seleted=index, openModal('CHARTER')" alt="">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="new-item h-align" @click="addManager('CHARTER')">
                    <img src="@/assets/img/icon/gray_add.svg" alt="">
                    新增
                </div>
            </div>
        </toogle-block>
        <toogle-block>
            <div class="toogle-title" slot="toogle-title">
                代管 - 不動產經紀人
            </div>
            <div class="toogle-body block" slot="toogle-body">
                <div v-if="isLoading" class="is-loading">
                    <table-loading />
                </div>
                <div class="content" v-if="list.estateAgentList.length">
                    <div class="table-title h-align">
                        <div class="name">姓名</div>
                        <div class="certification">認證字號</div>
                        <div class="address">通訊地址</div>
                        <div class="phone">聯絡電話</div>
                        <div class="signature">上傳簽名</div>
                        <div class="action">操作</div>
                    </div>
                    <div class="table-body">
                        <ul>
                            <li class="h-align" v-for="(item, index) in list.estateAgentList" :key="'estateAgentList'+index">
                                <div class="name">{{item.managerName}}</div>
                                <div class="certification">{{item.certificateNum}}</div>
                                <div class="address">{{item.managerAddress}}</div>
                                <div class="phone">{{item.managerTel}}</div>
                                <div class="signature">
                                    <div v-show="item.managerSignature" class="image-wrap">
                                        <img ref="estate" :src="item.managerSignature" alt="">
                                    </div>
                                    <div v-show="!item.managerSignature">
                                        -
                                    </div>
                                </div>
                                <div class="action">
                                    <img src="@/assets/img/icon/edit_gray.svg" @click="status.seleted=index, editManager('ESCROW')" alt="">
                                    <img src="@/assets/img/icon/trash2.svg" @click="status.seleted=index, openModal('ESCROW')" alt="">
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="new-item h-align" @click="addManager('ESCROW')">
                    <img src="@/assets/img/icon/gray_add.svg" alt="">
                    新增
                </div>
            </div>
        </toogle-block>
    </div>
</template>
<script>
import toogleBlock from '@/components/bussiness/widges/tools/toogleBlock.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import newManager from '@/components/bussiness/settingCenter/contractSetting/newManager.vue';
import FileUpload from 'vue-upload-component';
import Modal from '@/components/widge/Modal.vue';
import tableLoading from '@/components/bussiness/widges/tools/tableLoading.vue';
import { mapGetters } from 'vuex'

import { 
    setContractSetting,
    getContractSetting,
    previewContractSetting,
    delRentalAgent,
    delEstateAgent
    } from "@/apis/company/contractSetting.js"; 

export default {
    data () {
        return {
            componentKey: 0,
            contractSetting: {
                registrationCertificateNum:'',
                companyTel:'',
                companyMail:'',
                corporateSeal:[],
                managerName:'',
                certificateNum:'',
                previewImg: '',
            },
            list: {
                rentalAgentList: [],
                estateAgentList: []
            },
            error: {
                registrationCertificateNum: null,
                companyTel: null,
                companyMail: null,
                corporateSeal: null,
            },
            address: {
                county: {
                    state: false,
                    msg: '縣市'
                },
                district: {
                    state: false,
                    msg: '區域'
                },
                road: {
                    state: false,
                    msg: '路名',
                    selectedRoad: null
                }
            },
            flag: {
                isWidth: true,
                signatureIsWidth: true,
                isResize: false
            },
            status: {
                addManagerType: null,
                seleted: null,
                isEdit: false,
                editObj: {}
            },
            modalState:{
                deleteRentalAgent: false,
                deleteEstateAgent: false,
            },
            isLoading: true
        }
    },
    props: {
        submit: 0,
        preview: 0,
        type: null
    },
    mounted () {
        this.getContractSetting()
    },
    watch: {
        submit: function (val) {
            // console.log(val)
            if(val){
                this.saveContractSetting()
            }
        },
        preview: function (val) {
            // console.log(val)
            if(val){
                this.previewContractSetting()
            }
        },
        contractSetting: {
            handler: function (val) {
                //負責人姓名
                if(val.registrationCertificateNum){
                    if(this.checkStringLessThanNum(val.registrationCertificateNum, 50)){
                        this.error.registrationCertificateNum = null
                    }else{
                        this.error.registrationCertificateNum = '需少於50字'
                    }
                }
                //公司名稱
                if(val.companyTel){
                    if(this.checkStringLessThanNum(val.companyTel, 20)){
                        this.error.companyTel = null
                    }else{
                        this.error.companyTel = '需少於20字'
                    }
                }
                
              
                if(val.corporateSeal.length > 0){
                    this.flag.isResize = false
                    this.error.corporateSeal = null
                    let reader = new FileReader();
                    reader.readAsDataURL(val.corporateSeal[0].file)
                    setTimeout(()=>{
                        console.log(reader.result)
                        this.getImageWidthAndHeight(reader.result, 400, 200, 'stamp')
                    }, 1000)
                }
                if(val.previewImg && !val.corporateSeal.length){
                    setTimeout(()=>{
                        this.getImageWidthAndHeight(val.previewImg, 400, 200, 'stamp')
                    },500)
                }
            },
            deep: true
        },
        'list.rentalAgentList': function (val) {
            setTimeout(()=>{
                 console.log('list', val)
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    if(element.managerSignature){
                        console.log(i)
                        this.getImageWidthAndHeight(element.managerSignature, 100, 50, 'rental', i)
                    }
                }
            },500)
           
        },
        'list.estateAgentList': function (val) {
            setTimeout(()=>{
                console.log('list', val)
                for (let i = 0; i < val.length; i++) {
                    const element = val[i];
                    if(element.managerSignature){
                        this.getImageWidthAndHeight(element.managerSignature, 100, 50, 'estate', i)
                    }
                }
            },500)
        }
    },
    methods: {
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
            
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳JPG或PNG檔案',type: 'error'})
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
            
        },
        addManager: function (type){
            this.status.addManagerType = type
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizNewManager'})
        },
        getImageWidthAndHeight: function (val, width, height, type, index) {
            let newImg = new Image()
            newImg.src = val
            let hRatio;
            let wRatio;
            let Ratio = 1;
            setTimeout(()=>{
                let w = newImg.width;
                let h = newImg.height;

                wRatio = width / w;
                hRatio = height / h;
                if (wRatio<1 || hRatio<1){
                    Ratio = (wRatio<=hRatio?wRatio:hRatio);
                }
                if (Ratio<1){
                    w = w * Ratio;
                    h = h * Ratio;
                }
                console.log('resize')
                if(type === 'rental' || type === 'estate'){
                    this.$refs[type][index].width = w
                    this.$refs[type][index].height = h
                }else{
                    this.flag.isResize = true
                    this.$refs[type].width = w
                    this.$refs[type].height = h
                }
                
                
            }, 500)
        },
        saveContractSetting: function () {
            let formData = new FormData();
            formData.append('registrationCertificateNum', this.contractSetting.registrationCertificateNum);
            formData.append('companyTel', this.contractSetting.companyTel);
            formData.append('companyMail', this.contractSetting.companyMail);
            if(this.contractSetting.corporateSeal.length > 0){
                formData.append('corporateSeal', this.contractSetting.corporateSeal[0].file);
            }
        
            setContractSetting(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '企業合約設定儲存成功',type: 'success'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        previewContractSetting: function () {
            let formData = new FormData();
        
            formData.append('contractMode', this.type);
            formData.append('registrationCertificateNum', this.contractSetting.registrationCertificateNum);
            formData.append('companyTel', this.contractSetting.companyTel);
            formData.append('companyMail', this.contractSetting.companyMail);
            if(this.contractSetting.corporateSeal.length > 0){
                formData.append('corporateSeal', this.contractSetting.corporateSeal[0].file);
            }
           
        
            previewContractSetting(formData)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // this.$router.push({name: 'bizPreviewContract'})
                    localStorage.setItem('previewContract', res.data.result);
                    let routeData = this.$router.resolve({name: 'bizPreviewContract'});
                    let windowRef = window.open(routeData.href, '_blank');
                    // this.$store.dispatch('setBizPreviewContract', res.data.result)
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
            })
            .catch(err => {
                console.log(err)
            })

        },
        getContractSetting: function () {
            getContractSetting().then(res => {
                console.log('getContractSetting',res)
                if( res.data.status == "SUCCESS" ){
                    let contractSetting = this.contractSetting
                    let result = res.data.result
                    contractSetting.registrationCertificateNum = result.registrationCertificateNum
                    contractSetting.companyTel  = result.companyTel
                    contractSetting.companyMail  = result.companyMail
                    contractSetting.previewImg  = result.corporateSeal
                    this.list.estateAgentList = result.estateAgentList
                    this.list.rentalAgentList = result.rentalAgentList
                    this.componentKey += 1
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                }
                this.isLoading = false
            })
            .catch(err => {
                console.log(err)
                this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                this.isLoading = false
            })
        },
        openModal: function (type) {
            this.$store.commit('modalStatus/set_modal_mode', true)
            if(type === 'CHARTER'){
                this.modalState.deleteRentalAgent = true
            }else{
                this.modalState.deleteEstateAgent = true
            }
        },
        closeModal: function (type) {
            console.log(type)
            this.$store.commit('modalStatus/set_modal_mode', false)
            if(type === 'CHARTER'){
                this.modalState.deleteRentalAgent = false
            }else{
                this.modalState.deleteEstateAgent = false
            }
        },
        deleteManager: function (type) {
            let data 
            if(type === 'CHARTER'){
                data = {
                    managerId: this.list.rentalAgentList[this.status.seleted].managerId
                }
                delRentalAgent(data).then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '刪除成功',type: 'success'})
                        this.getContractSetting()
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                })
            }else{
                data = {
                    managerId: this.list.estateAgentList[this.status.seleted].managerId
                }
                delEstateAgent(data).then(res => {
                    if( res.data.status == "SUCCESS" ){
                        this.$store.dispatch('setAlarmStatus', {status: true,title: '刪除成功',type: 'success'})
                        this.getContractSetting()
                    }else{
                        this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg,type: 'error'})
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.$store.dispatch('setAlarmStatus', {status: true,title: err,type: 'error'})
                })
            }
            this.closeModal(type)
        },
        editManager: function (type) {
            this.status.addManagerType = type
            this.$store.dispatch('setModalStatus', {state: true, type: 'bizNewManager'})
            this.status.isEdit = true
            if(type === 'CHARTER'){
                this.status.editObj = this.list.rentalAgentList[this.status.seleted]
            }else{
                this.status.editObj = this.list.estateAgentList[this.status.seleted]
            }
        },
        setEditDefault: function () {
            this.status.isEdit = false
            this.status.editObj = {}
        }
    },
    computed: {
        previewImg: function () {
            if( this.contractSetting.corporateSeal.length > 0){
                // this.flag.isResize = true
                return this.contractSetting.corporateSeal[0].blob
            }else if( this.contractSetting.previewImg ){
                return this.contractSetting.previewImg
            }
        },
        filterRoad: function () {
            return this.roads.filter((road) => {
                // console.log(road.roadStreetName)
                if( this.address.road.selectedRoad ){
                    if(road.roadStreetName.includes(this.address.road.selectedRoad)){
                        return road
                    }
                }else{
                    return road
                }
            });
        },
        ...mapGetters({
            counties: 'COUNTY_RESULT',
            districts: 'DISTRICTS_RESULT',
            roads: 'ROAD_RESULT',
        })
    },
    components: {
        toogleBlock,
        RentSelect,
        RentSelectFilter,
        newManager,
        FileUpload,
        Modal,
        tableLoading
    }
}
</script>
<style lang="scss" scoped>
    .contract-setting-comp{
        margin-bottom: 200px;
        #modal.delete{
            .modal-content{
                padding: 0 !important;
                .alarm-img{
                    margin-top: 40px;
                }
                h1{
                    font-size: 24px;
                    margin-top: 12px;
                    margin-bottom: 16px;
                }
                .content{
                    padding: 0 40px;
                    width: 368px;
                    line-height: 1.57;
                    color: #a8a5a4;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
        .block{
            .is-loading{
                position: relative;
                width: 50px;
                margin: 0 auto;
                margin-bottom: 30px;
            }
            >div{
                &:last-child{
                    margin-bottom: 0;
                }
                width: 424px;
                margin-bottom: 24px;
                .couty-group{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 8px;
                    .county,
                    .district{
                        width: 86px;
                    }
                    .road{
                        width: 140px;
                        input{
                            width: 140px;
                        }
                    }
                    .error{
                        bottom: unset;
                    }
                }
            }
            .image-cover{
                position: absolute;
                top: 77px;
                right: 90px;
                margin-bottom: 30px;
                .cover-block{
                    position: relative;
                    width: 400px;
                    height: 200px;
                    border-radius: 4px;
                    border: solid 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        margin-bottom: 4px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .img-error{
                        position: absolute;
                        width: 200px;
                        left: 136px;
                        font-weight: 500;
                        font-size: 12px;
                        color:  #F05A3E;
                        top: unset;
                    }
                }
                .cover-block.img-error{
                    border: dashed 1px #F05A3E;
                }
                .cover-preview{
                    display: flex;
                    align-items: flex-start;
                    width: 500px;
                    .preview{
                        width: 400px;
                        height: 200px;
                        display: flex;
                        margin-right: 10px;
                        align-items: center;
                        justify-content: center;
                        border-radius: 4px;
                        border: solid 1px #cacfcd;
                        // overflow: hidden;
                    }
                    .replace{
                        width: 74px;
                        height: 32px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        background: #fff;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
            .content{
                width: 1140px;
                margin-bottom: 8px;
                margin-left: -22px;
                margin-right: -22px;
                padding: 20px 0px;
                .table-title{
                    padding: 20px 25px;
                    border-top: 1px solid #F1F5F4;
                    border-bottom: 1px solid #F1F5F4;
                    color: #a8a5a4;
                }
                .table-body ul li{
                    padding: 13px 25px;
                    border-bottom: 1px solid #F1F5F4;
                }
                .table-title .name,
                .table-body ul li .name{
                    width: 62px;
                    margin-right: 72px;
                }
                .table-title .certification,
                .table-body ul li .certification{
                    width: 76px;
                    margin-right: 71px;
                }
                .table-title .address,
                .table-body ul li .address{
                    width: 243px;
                    margin-right: 92px;
                }
                .table-title .phone,
                .table-body ul li .phone{
                    width: 98px;
                    margin-right: 83px;
                }
                .table-title .signature,
                .table-body ul li .signature{
                    width: 110px;
                    margin-right: 82px;
                }
                .table-body ul li .signature .image-wrap{
                    border: solid 1px #e0dfde;
                    border-radius: 2px;
                    width: 100px;
                    height: 50px;
                    overflow: hidden;
                    text-align: center;
                }
                .table-title .action,
                .table-body ul li .action{
                    width: 100px;
                }
                .table-body ul li .action{
                    >img{
                        margin-right: 13px;
                        cursor: pointer;
                    }
                }
            }
            .new-item{
                border: dashed 1px #c5c2c1;
                border-radius: 4px;
                width: 100%;
                height: 56px;
                justify-content: center;
                cursor: pointer;
            }
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/bussiness/settingCenter/contractSetting/contractSettingComp.vue